import { useLocation, useNavigate } from "react-router-dom"
import React, { useEffect, useState } from 'react';
import styled from "styled-components"
import { productlist } from "./Product"
import { InputNumber,message } from 'antd';
import { Image,Button } from 'antd';
import { Typography } from 'antd';
import {setDoc,Timestamp,doc,getDoc } from "firebase/firestore";
import { auth,db} from "../Config";
import { v4 as uuidv4 } from 'uuid';

const { Title } = Typography;
export default function Info(){
    let location = useLocation()
    const navigate = useNavigate()
    const item = new URLSearchParams(location.search)
    const id = Number(item.get('id'))
    const [size,setSize] = useState(35)
    const [number,setNumber] = useState(1)
    const [info,setInfo] = useState({})
    const [cart,setCart] = useState([])
    const InfoField = styled.div`
        width:88%;
        min-height:100vh;
        padding:16vh 3vw 2vh 15vw;
        @media (max-width:767px){
            width:95%;
            padding:16vh 3vw 2vh 0vw;
        }
    `
    const InfoContainer = styled.div`
        margin:0 10vw 0 5vw;
        width:80%;
        min-height:90vh;
        display:flex;
        background-color:#f5eedb;
        border-radius:30px;
        @media (max-width:1023px) and (min-width:768px){
            width:110%;
        }
        @media (max-width:767px){
            margin:0 5vw 0 5vw;
            width:100%;
            flex-direction:column;
            align-items:center;
        }
    `
    const ImgField = styled.div`
        width:25vw;
        height:100vh;
        padding:8vh 0 0 5vw;
        border-radius:20px;
        overflow: hidden;
        @media (max-width:1023px) and (min-width:768px){
            width:35vw;
        }
        @media (max-width:767px){
            height:50vh;
            width:80vw;
            padding:8vh 0 0 0vw;
            display: flex;
            margin-left:15vw;
        }
        .info-img{
            width:18vw;
            height:40vh;
            border-radius:20px;
            object-fit:cover;
            @media (max-width:1023px) and (min-width:768px){
                width:30vw;
            }
            @media (max-width:767px){
                width:100%;
                
            }
        }
    `
    const InfoContent = styled.div`
        margin:8vh 4vw 0 2vw;
        width:45%;
        height:100%;
        font-family: Arial, Helvetica, sans-serif;
        display:flex;
        flex-direction:column;
        @media (max-width:767px){
            width:70%;
        }
        .info-btn{
            width:20vw;
            height:8vh;
            margin-bottom:2vh;
            border-radius:10px;
            background-color:tomato;
            color:white;
            :hover{
                background-color:transparent;
                color:tomato;
                border:1px solid tomato
            }
            @media (max-width:767px){
                width:50vw;
            }   
        }
    `
    useEffect(()=>{
        setInfo({
            id:id,
            name:productlist[id].name,
            info:productlist[id].info,
            material:productlist[id].material,
            cost:productlist[id].cost,
            costNum:productlist[id].costNum,
            img:productlist[id].img,
            itemId:uuidv4(),
            size:size,
            number:number,
            totalCost:productlist[id].costNum*number,
            createAt:Timestamp.fromDate(new Date()),
        })
    },[size,number])
    function ImageDemo() {
        return (
          <Image
            className="info-img"
            src={productlist[id].img}
          />
        );
    }
    const key = 'updatable';
    const openMessage = () => {
    message.loading({ content: 'Đang xử lí...', key });
    setTimeout(() => {
        message.success({ content: 'Đã thêm vào giỏ hàng!', key, duration: 2 });
    }, 1000);
    setCart(prev=>[...prev,info])
    setDoc(doc(db,'cartlist',auth.currentUser.uid,'cart',info.itemId),info)
    };
    return(
        <InfoField>
            <InfoContainer>
                <ImgField>
                    <ImageDemo />
                </ImgField>
                <InfoContent>
                    <Title level={4}>{productlist[id].name}</Title>
                    <Title level={5} style={{marginTop:'0',color:'tomato'}}>{productlist[id].cost}</Title>
                    <p>{productlist[id].material}</p>
                    <p>Size(35-42):</p>
                    <InputNumber min={35} max={42} defaultValue={size} style={{width:'20%',marginBottom:'2vh'}} onChange={e=>setSize(e)}/>
                    <p>Số Lượng:</p>
                    <InputNumber min={1} defaultValue={number} style={{width:'20%',marginBottom:'2vh'}} onChange={(e)=>{setNumber(e)}}/>
                    <Title level={5} style={{marginTop:'0',color:'tomato'}}>Tổng tiền: {productlist[id].costNum*number}đ</Title>
                    <Button className="info-btn" onClick={openMessage}>Thêm vào giỏ hàng</Button>
                    <p>{productlist[id].info}</p>
                </InfoContent>
            </InfoContainer>
        </InfoField>
    )
}